import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import Flag from "./Flag";
const useStyles = makeStyles({
  flagContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxHeight: ({
      compact
    }) => compact ? 22 : 50
  },
  prefixStyle: {
    marginLeft: 10
  }
});
const FlagMenuItem = ({
  flag,
  label,
  countryCode,
  showFlag = true,
  compact = false
}) => {
  const classes = useStyles({
    compact
  });
  return /*#__PURE__*/React.createElement("span", {
    className: classes.flagContainer
  }, showFlag && /*#__PURE__*/React.createElement(Flag, {
    countryCode: countryCode,
    flag: flag,
    size: "small"
  }), /*#__PURE__*/React.createElement(Typography, {
    component: "span",
    className: classes.prefixStyle
  }, label));
};
export default FlagMenuItem;
FlagMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
  flag: PropTypes.string,
  showFlag: PropTypes.bool,
  compact: PropTypes.bool
};